const SG = {
  company: [
    "private limited company (Pte Ltd)",
    "exempt private company (EPC)",
    "non-profit society"
  ],
  legalArrangement: [
    "limited liability partnership (LLP)",
    "society",
    "limited partnership (LP)"
  ]
};
export {
  SG as default
};
